// 공지사항 작성하기
export const CREATE_NOTICE_REQUEST = 'CREATE_NOTICE_REQUEST';
export const CREATE_NOTICE_SUCCESS = 'CREATE_NOTICE_SUCCESS';
export const CREATE_NOTICE_FAIL = 'CREATE_NOTICE_FAIL';
// 공지사항 리스트 가져오기
export const GET_NOTICE_LIST_REQUEST = 'GET_NOTICE_LIST_REQUEST';
export const GET_NOTICE_LIST_SUCCESS = 'GET_NOTICE_LIST_SUCCESS';
export const GET_NOTICE_LIST_FAIL = 'GET_NOTICE_LIST_FAIL';
// 공지사항 수정하기
export const EDIT_NOTICE_REQUEST = 'EDIT_NOTICE_REQUEST';
export const EDIT_NOTICE_SUCCESS = 'EDIT_NOTICE_SUCCESS';
export const EDIT_NOTICE_FAIL = 'EDIT_NOTICE_FAIL';
// 공지사항 삭제하기
export const DELETE_NOTICE_REQUEST = 'DELETE_NOTICE_REQUEST';
export const DELETE_NOTICE_SUCCESS = 'DELETE_NOTICE_SUCCESS';
export const DELETE_NOTICE_FAIL = 'DELETE_NOTICE_FAIL';
// 선택된 공지사항
export const SET_SELECTED_NOTICE = 'SET_SELECTED_NOTICE';
// 사용자 공지사항 페이지에 보여줄 리스트 분리
export const GET_USER_NOTICE_LIST_SUCCESS = 'GET_USER_NOTICE_LIST_SUCCESS';
// 메인페이지 공지사항
export const GET_MAIN_NOTICE_LIST_REQUEST = 'GET_MAIN_NOTICE_LIST_REQUEST';
export const GET_MAIN_NOTICE_LIST_SUCCESS = 'GET_MAIN_NOTICE_LIST_SUCCESS';
export const GET_MAIN_NOTICE_LIST_FAIL = 'GET_MAIN_NOTICE_LIST_FAIL';
